(() => {
 const interest = new URLSearchParams(location.search).get('interest');
 const select = document.getElementById('ContactInterest');
 if (select && interest && [...select.options].some(o => o.value === interest)) select.value = interest;
 const variant = document.getElementById('ProductVariant');
 if (variant) variant.addEventListener('change', () => {
   const option = variant.selectedOptions[0];
   const price = document.getElementById('ProductPrice');
   const submit = document.getElementById('AddToCart');
   price.textContent = option.dataset.price;
   submit.disabled = option.dataset.available !== 'true';
   submit.textContent = submit.disabled ? 'Sold out' : 'Add to cart';
 });
 if (window.Shopify && Shopify.designMode) {
   document.body.classList.add('shopify-design-mode');
   // The source interactions initialize once. Reload after section changes so
   // mobile disclosures, carousels and new quiz buttons get fresh listeners.
   document.addEventListener('shopify:section:load', () => location.reload());
 }
})();